import React, { useEffect, useState } from "react";
import "./feed-back-pages.scss"
import { Form } from 'react-bootstrap';
import ReCaptcha from "../../components/commons/recaptcha/recaptcha.component";
import CustomButton from "../../components/commons/custom-button/custom-button.component";
import Hero from "../../components/commons/hero/hero.component";
import { useDispatch, useSelector } from "react-redux";
import { getFeedbackData } from "../../redux/feed-back-data/feedback.action";
import Loader from "../../components/commons/helpers/loader/loader.component";
import { FeedbackServices } from "../../redux/feed-back-data/feedback.services";
import { useHistory } from "react-router-dom";
import { handleNotify } from "../../js/helpers/toaster/toaster-notify";
import { ToasterPositions } from "../../js/helpers/toaster/toaster-positions";
import { ToasterTypes } from "../../js/helpers/toaster/toaster-types";
import EmptyTableComponent from "../../components/ecommerce/empty-component/empty-table-compontent";
import ErrorDisplay from "../specialty-pages/error-display/error-display.page";
import EmptyShoppingCart
    from "../../components/ecommerce/new-shopping-cart-items/empty-shopping-cart/empty-shopping-cart";

const FeedbackComponent = ({ content, subTitle, subContent, questionHeading, data, props }) => {

    const dispatch = useDispatch();

    const feedBackData = useSelector(state => state.feedback.feedbackData);
    const acceptanceStatusData = useSelector(state => state.feedback.acceptanceStatus);

    useEffect(() => {
        dispatch(getFeedbackData(props.token))

        if (acceptanceStatusData !== undefined && acceptanceStatusData.Complete && acceptanceStatusData.SurveyResponseId === 0 && acceptanceStatusData.Name === "None") {
            history.push({
                pathname: '/feedBackClosedPage',
                state: {
                    SessionId: acceptanceStatusData.SessionId,
                    AttendeeId: acceptanceStatusData.AttendeeId
                }
            });
        } else if (acceptanceStatusData !== undefined && acceptanceStatusData.Complete) {
            history.push({
                pathname: '/feedBackThankYouPage',
                state: {
                    SessionId: acceptanceStatusData.SessionId,
                    AttendeeId: acceptanceStatusData.AttendeeId
                }
            });
        }
    }, [acceptanceStatusData]);

    const history = useHistory();


    if (typeof feedBackData === "string") {
        return <Loader />
    }

    let userFeedBackData = [];

    const onChangeData = (element, questionData) => {
        userFeedBackData = userFeedBackData.filter(e => e.Id !== questionData.Id).concat(Object.assign(questionData, { UserAnswer: [element] }));
    }

    const onSubmitData = () => {
        let data = {
            requeststream: userFeedBackData
        }

        let firstQuestion = feedBackData && feedBackData[0];
        let textfieldlengh = data.requeststream.filter(x => x.Id == 223 || x.Id == 224 || x.Id == 225 || x.Id == 226).length;
            
        if (feedBackData.length - 4 > data.requeststream.length - textfieldlengh) {
            handleNotify('Please fill & select all the questions and answers.', ToasterTypes.Error);
        }
        else {
            FeedbackServices.submitFeedBackData(data).then(() => {
                handleNotify('Feedback submitted successfully.', ToasterTypes.Success);
                history.push({
                    pathname: '/feedBackThankYouPage',
                    state: {
                        SessionId: firstQuestion.SessionId,
                        AttendeeId: firstQuestion.AttendeeId
                    }
                });
            })
        }
    };

    if (feedBackData === undefined) {
        return <EmptyTableComponent message={"No survey available."} style={{ marginTop: 8 }} />
    }

    return (
        <>
            <Hero
                title={"Course Evaluation"}
                template={"standard"}
                altMobileTitle={true}
                colorCategory={'gen'}
            />
            <div className={"trinity-container feedback"}>
                <div className={"outer-div"}>
                    <div className={"sub-title-content"}>
                        <h5 className={"sub-title"}>{feedBackData && feedBackData.length > 0 && feedBackData[0].CourseName}</h5>
                        <p className={"sub-content"}>{subContent}</p>
                    </div>
                    <div className={"que-heading"}>
                        <p>{questionHeading}</p>
                    </div>
                    {
                        feedBackData && feedBackData.map((question) => {
                            switch (question.QuestionType.toLowerCase()) {
                                case "multiplechoice":
                                    return (
                                        <div key={Math.random()} className={"radio-design"}>
                                            <p className={"question-text"}>{question.QuestionValue}</p>
                                            <Form>
                                                {
                                                    ['radio'].map((type) => (
                                                        <div className={"radio-div"}>
                                                            {
                                                                question.AvailableAnswers.map((option) =>
                                                                    <Form.Check inline label={option.Value}
                                                                        type={"radio"}
                                                                        key={Math.random()}
                                                                        name={"radioName"}
                                                                        onChange={(event) => onChangeData(option.Id, question)}
                                                                        id={option.value} />
                                                                )
                                                            }
                                                        </div>
                                                    ))}
                                            </Form>

                                        </div>
                                    );

                                case "text":
                                    return (
                                        <div key={Math.random()} className={"sub-div"}>
                                            <Form.Group key={Math.random()} controlId="exampleForm.ControlTextarea1">
                                                <p className={"question-text"}>{question.QuestionValue}</p>
                                                <Form.Control key={Math.random()}
                                                    as="textarea"
                                                    rows="3"
                                                    onChange={(event) => onChangeData(event.target.value, question)}
                                                    className={"area"} />
                                            </Form.Group>
                                        </div>
                                    );


                            }
                        }
                        )
                    }

                    <div className="recaptcha-div">
                        <ReCaptcha />
                    </div>

                    <div className="custome-button-div">
                        <CustomButton className="heroLink" onClick={() => onSubmitData()} title={"Submit"} />
                    </div>
                </div>
            </div>
        </>
    );
}
export default FeedbackComponent;
